<template>
  <div class="view pa24">
    <el-dialog
        :title="title"
        width="800px"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :before-close="closeDialog"
    >
     <div class="dialogBody">
       <el-form :model="form" class="demo-form-inline">
         <el-row style="padding-top: 20px;">
           <el-col :span="20">
             <el-form-item label="标识码:" label-width="100px" label-position="left" class="fromItem">
               <el-input v-model="form.handle" placeholder="请输入标识码" clearable style="width: 300px"></el-input>
             </el-form-item>
             <el-button type="primary" class="myBtn" @click="serchquery">查询</el-button>
             <el-button type="primary" class="myBtn" @click="reset">重置</el-button>
           </el-col>
         </el-row>
       </el-form>
       <el-empty description="暂无数据" v-if="lineDataList.length <=0 && !handleInfo"></el-empty>
       <div v-else class="timeDiv">
         <el-divider content-position="left">产品信息</el-divider>
         <div >
           <el-descriptions title="" column="1" style="font-weight: bold;margin-bottom: 10px">
             <el-descriptions-item   label="类型：">{{handleInfo.type==3?"箱":handleInfo.type==5?"盒":"瓶"}}</el-descriptions-item>
             <el-descriptions-item label="产品名称：" v-if="handleInfo.className">{{handleInfo.className}}</el-descriptions-item>
             <el-descriptions-item label="产品编码：" v-if="handleInfo.goodsCode">{{handleInfo.goodsCode}}</el-descriptions-item>
             <el-descriptions-item label="规格型号：" v-if="handleInfo.goodsCode">{{handleInfo.goodsCode}}</el-descriptions-item>
           </el-descriptions>

         </div>

         <el-divider content-position="left">溯源时间轴</el-divider>
         <el-timeline class="contentMain"  v-if="lineDataList.length>0">
           <el-timeline-item
               v-for="(item, index) in lineDataList"
               :key="index"
               :timestamp="item.createTime">
             <el-tag type="info" v-if="item.revokeStatus == 1">已撤销</el-tag>
             <span v-if="item.wareStatus===1">入库: {{item.warehouseName}}<span v-if="item.operationDealer">({{item.operationDealer}})</span> | </span>
             <span v-else-if="item.wareStatus===2">出库: {{item.dealerName}} | </span>
             <span v-else-if="item.wareStatus === 3">退货: {{item.dealerName}} | </span>
             <span v-else-if="item.wareStatus === 6">更改代理商为：【{{item.dealerName}}】 | </span>
             <span> 操作人: {{item.createBy}} |</span>
             <span v-if="item.handle&&item.isBox!==isBox">
              <span :class="item.isBox ? 'box' : 'pack'" style="padding-right: 0;">{{item.isBox ? '箱' : '盒' }}</span>{{item.handle}}
          </span>
           </el-timeline-item>
         </el-timeline>
         <div v-else style="text-align: center">暂无数据</div>
       </div>
     </div>
    </el-dialog>
  </div>
</template>

<script>


import {get} from "@/utils/request";

export default {
  name: "handleSourceDialog",
  data() {
    return {
      dialogVisible: false,
      title: '溯源',
      form:{
        handle:''
      },
      lineDataList: [],
      handleInfo:''
    };
  },
  components: {


  },
  onShow() {

  },
  methods: {
    openDialog() {
      this.form.handle=''
      this.handleInfo=''
      this.lineDataList = []
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    getList() {

    },
    serchquery(){
      this.initList(this.form.handle)
      this.getHandleInfo()
    },
    reset(){
      this.form.handle=''
      this.handleInfo=''
      this.lineDataList = []
    },
    initList(handle){
      get('/crk/app/sourceLog',{handle:handle}).then(res=>{
        this.lineDataList=res;
      })
    },
    getHandleInfo(){
      get('/crk/app/sourceHandleInfo',{handle:this.form.handle}).then(res=>{
        this.handleInfo=res;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10 rpx;
}
.dialogBody{
  //max-height: 50vh;
  //overflow-y: scroll;
}
.fromItem{
  display: inline-block;
}
.myBtn{
  margin-left: 10px;
}
.timeDiv{
  margin-left: 42px;
  margin-top: 20px;
}
/deep/.el-descriptions__body .el-descriptions__table{
  color: #000000;
  font-size: 14px;
  font-weight: bold;
}
</style>
